import { formatPhp } from '@naya/shared'
import type { InvoiceStatus } from './types.js'

/** Date only — "14 May 2026". Null-safe. */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  return new Date(iso).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

/** Date + time — "14 May, 4:32 PM". Used in audit/activity lists. */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  return new Date(iso).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/** Centavos → "₱1,500.00". */
export function fmtMoney(centavos: number): string {
  return formatPhp(centavos)
}

/** Maps an invoice status to the badge variant class suffix. */
export function invoiceBadgeVariant(status: InvoiceStatus): string {
  switch (status) {
    case 'paid':
      return 'ok'
    case 'unpaid':
      return 'warn'
    case 'overdue':
      return 'danger'
    case 'void':
      return 'neutral'
  }
}
